<img src="assets/img/building.jpg" alt="" class="img">
<div class="imgBox" [class]="theme.myIconBgColor">
    <h3>{{title}}</h3>
</div>
